import 'console-polyfill'
import 'custom-event-polyfill'
import './core/Sentry'
// jquery utils
import 'jquery.easing'
import './plugins/nette.ajax'
import './plugins/nette.ajax.history'
// nette
import './nette/NetteAutosubmit'
import './nette/NetteValidationMessages'
import './nette/NetteSnippets'
import './nette/NetteEvents'
import './nette/NetteLoading'

import elementClosestPolyfill from 'element-closest'
import $ from 'jquery'
/**
 * lazy loading
 */
import lazySizes from 'lazysizes'

import { loadComponents, removeComponents } from './core/componentUtils'
// set basepath of project for webpack
import { basePath, CMS, isNativeScroll, USE_NATIVE_SCROLL } from './core/config'
import EventBus from './core/EventBus'
import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
import Nette from './nette/NetteForms'
import ScrollService, {
  scrollToElement,
  setScrollPosition,
} from './services/Scroll'
import { scrollHistory } from './services/ScrollHistory'
import { runSwup } from './services/Swup'
import { runScriptsInsideElement } from './utils/script'

__webpack_public_path__ = `${basePath}/assets/frontend/js/`

// Editor (admin mód) volá window.frontend.loadComponents/removeComponents, aby se
// po vykreslení widgetu znovu zaregistrovaly FE komponenty uvnitř něj.
window.frontend = {
    loadComponents,
    removeComponents,
}

elementClosestPolyfill(window)

window.Nette = Nette
Nette.initOnLoad()

if ($.nette) {
    $.nette.init()
}

new TouchMouseInputResolver()

if (USE_NATIVE_SCROLL) {
    ScrollService.useNative()
} else {
    ScrollService.useVirtual()
}

loadComponents()

lazySizes.cfg.lazyClass = 'is-lazy'
lazySizes.cfg.loadingClass = 'is-lazy-loading'
lazySizes.cfg.loadedClass = 'is-lazy-loaded'

// V CMS/editor módu swup nespouštíme — je to jedna stránka bez navigace a jeho
// linkSelector chytal i CKEditor tlačítka (<a href="javascript:void(…)">), což přes
// hook link:self skákalo scrollem na hlavičku.
if (!CMS) {
    runSwup({
        Nette,
        ScrollService,
        EventBus,
        scrollToElement,
        loadComponents,
        removeComponents,
        scrollHistory,
        setScrollPosition,
        runScriptsInsideElement,
        isNativeScroll,
    })
}
